import { LOGIN_SUCCESS, LOGOUT } from "../actions/authActions";

// ── Rehydrate state from localStorage on page refresh ──
const loadAuthState = () => {
  try {
    const serialized = localStorage.getItem("authUser");

    if (!serialized) {
      return {
        user: null,
        accessToken: null,
        refreshToken: null,
        isAuthenticated: false,
      };
    }

    return JSON.parse(serialized);
  } catch {
    return {
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
    };
  }
};

const initialState = loadAuthState();

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      const newState = {
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        isAuthenticated: true,
      };

      localStorage.setItem("authUser", JSON.stringify(newState));

      return newState;
    }

    case LOGOUT:
      localStorage.removeItem("authUser");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      return {
        user: null,
        accessToken: null,
        refreshToken: null,
        isAuthenticated: false,
      };

    default:
      return state;
  }
};

export default authReducer;
